import logo from './logo.svg';
import './App.css';
import Dashboard from './Pages/Dashboard';
import { Route, Routes } from 'react-router-dom';
import AllProducts from './Components/Product/AllProducts';
import Header from './Components/Header';
import Footer from './Components/Footer/Footer';
import ProductDetails from './Components/Product/Details/ProductDetails';
import Countact from './Pages/Countact';
import About from './Pages/About';
import { useEffect, useState } from 'react';
import Checkout from './Pages/Checkout';
import TermsConditions from './Pages/TermsConditions';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import RefundReturn from './Pages/RefundReturn';
import Home from './Pages/Home';


function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handlePageLoad = () => {
    // Once the page is fully loaded, hide the loading screen
    setIsLoading(false);
  };

  useEffect(() => {
    // Simulate a loading delay for demonstration purposes
    window.addEventListener('load', handlePageLoad);

    return () => window.removeEventListener('load', handlePageLoad);
  }, []);

  // console.log("isLoading: ", isLoading);



  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<Dashboard />} />

        <Route path="/products" element={<AllProducts />} />
        <Route path="/products/:id" element={<ProductDetails />} />
        <Route path="/contact-us" element={<Countact />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/refund-return" element={<RefundReturn />} />
        <Route path="/share/:celebrityId" element={<Home />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
